import { cn } from '@landler/component-library';
import { HTMLAttributes } from 'react';

import { Icon } from '@/components/widgets/a/Icon/Icon';

type SidebarToggleButtonProps = HTMLAttributes<HTMLButtonElement> & {
  direction: 'left' | 'right';
  onClick: () => void;
  className?: string;
};

export const SidebarToggleButton = ({ direction, className, ...props }: SidebarToggleButtonProps) => {
  return (
    <button
      className={cn('rounded-full w-8 h-8 bg-primary-12 hover:bg-primary-30 transition-colors z-50', className)}
      {...props}
    >
      <Icon
        icon={direction === 'left' ? 'ri-arrow-left-s-line' : 'ri-arrow-right-s-line'}
        className='typography-button1 text-black-100'
      />
    </button>
  );
};
